export default () => {

    // Header Mobile Menu

    $('.nav .menu-item-has-children').append('<i class="nav-arrow icon-chevron-right"></i>');

    $('.nav .nav-arrow').on('click', function() {
        let $this = $(this);
        let sub = $this.parent().children('.sub-menu');

        if ($this.hasClass('active')) {
            $this.removeClass('active');
            sub.slideUp();
        } else {
            $('.nav').find('.menu-item-has-children .active').each(function() {
                let close = $(this);
                if ($this.closest(close.parent()).length == 0) {
                    close.removeClass('active');
                    close.parent().children('.sub-menu').slideUp();
                }
            });
            sub.slideUp();
            $this.addClass('active');
            sub.slideDown();
        }
    });

    $('.header-btn').click(function() {
        $('body').toggleClass('open-nav');
    });

    // Header Sticky

    $(window).scroll(function () {
        if ($(window).scrollTop() > 1) {
            $('.header').addClass('fixed');
        } else {
            $('.header').removeClass('fixed');
        }
    });

    // Height 100vh

    const appHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    }
    window.addEventListener('resize', appHeight);
    appHeight();

    // Accordion

    $('.accordion-content').hide();
    $('.accordion-caption.active ~ .accordion-content').show();

    $('.accordion-caption').click(function() {
        $(this).next().slideToggle(300);
        $('.accordion-content').not($(this).next()).slideUp(300);
        $(this).toggleClass('active');
        $('.accordion-caption').not($(this)).removeClass('active');
    });

    // Event Filter Bar

    $(document).on('click', '.js-event-tag-filter', function(e){
        e.preventDefault();
        let $this = $(this);
        let tag_id = $this.data('id');
        $this.addClass('active').siblings('.js-event-tag-filter').removeClass('active');
        $this.parents('.tribe-events').find('[name="tribe_tags[]"]').val(tag_id).change();
    });

    var currentLink = window.location.href;
    $(document).on('click', '.tribe-filter-bar-c-clear-button', function(e){
        e.preventDefault();
        window.location.href = currentLink;
    });

    // Grid Search

    setTimeout(function() {
        var $grid = $('.grid-search').masonry({
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
            percentPosition: true,
            horizontalOrder: true
        });
    }, 300);

    $('.js-start-search').click(function(e){
        e.preventDefault();
        $(this).parents('.block-search').find('.form-search').submit();
    });

    $('.js-clear-search').click(function(e){
        e.preventDefault();
        $(this).parents('.block-search').find('.input-search').val('');
        $(this).parents('.block-search').find('.form-search').submit();
    });

    // Popup

    $('[data-fancybox]').fancybox();

}
